import { render, staticRenderFns } from "./infoDemand.vue?vue&type=template&id=220dc61a&scoped=true&"
import script from "./infoDemand.vue?vue&type=script&lang=js&"
export * from "./infoDemand.vue?vue&type=script&lang=js&"
import style0 from "./infoDemand.vue?vue&type=style&index=0&id=220dc61a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220dc61a",
  null
  
)

export default component.exports